import React, { useEffect, useRef, useMemo } from 'react';
import clsx from 'clsx';
import Depot from '../../../../_shared/depot';
import useBubble from '../../../../Overlays/Bubble/useBubble';
import { listenerOutsideClick, listenerEscapeKeyDown, } from '../../../../Overlays/shared/helpers';
import BinaryFilterButton from '../../BinaryFilterButton';
import FilterBubbleMenuContent from '../../FilterBubbleMenuContent';
import * as styles from './style.module.css';
const Bubble = useBubble.Bubble({ as: 'dialog' });
const BubbleFilterButtonWithoutRef = ({ selected = false, isMenuOpen = false, clearable = false, buttonClearLabel = '', menuHeading = '', menuContent, menuSelectButtonLabel, menuClearButtonLabel, menuDoneButtonLabel = '', onMenuSelectButtonClick, onClear, onDone, bubbleProps: useBubbleProps, ...commonProps }) => {
    const refBubble = useRef(null);
    const refInteractiveElement = useRef(null);
    // Bubble hook
    const { targetProps, bubbleProps, visible, setVisible } = useBubble({
        direction: 'down right',
        hideNubbin: true,
        ...useBubbleProps,
    });
    // Listeners
    const handleOutsideClick = useMemo(() => listenerOutsideClick({
        refBubble,
        setVisible,
        refInteractiveElement,
        callback: onDone,
    }), [refBubble, onDone, setVisible, refInteractiveElement]);
    const handleEscapeKeyDown = useMemo(() => listenerEscapeKeyDown({
        setVisible,
        callback: onDone,
    }), [onDone, setVisible]);
    // Effects
    useEffect(() => {
        if (visible) {
            document.addEventListener('click', handleOutsideClick);
            document.addEventListener('touchstart', handleOutsideClick);
            document.addEventListener('keydown', handleEscapeKeyDown);
        }
        return () => {
            document.removeEventListener('click', handleOutsideClick);
            document.removeEventListener('touchstart', handleOutsideClick);
            document.removeEventListener('keydown', handleEscapeKeyDown);
        };
    }, [visible, handleOutsideClick, handleEscapeKeyDown]);
    useEffect(() => {
        setVisible(isMenuOpen);
        return () => setVisible(false);
    }, [isMenuOpen, setVisible]);
    const bubbleClasses = clsx(bubbleProps.largeViewportWrapperClasses, styles.bubble);
    return (React.createElement(useBubble.Target, { ...targetProps, ref: refInteractiveElement },
        React.createElement(BinaryFilterButton, { hasMenu: true, selected: selected, isMenuOpen: isMenuOpen, buttonClearLabel: buttonClearLabel, onClear: onClear, "aria-haspopup": true, "aria-expanded": isMenuOpen, "aria-pressed": selected, ...commonProps }),
        React.createElement(Bubble, { ...bubbleProps, ref: refBubble, largeViewportWrapperClasses: bubbleClasses, visible: visible },
            React.createElement(FilterBubbleMenuContent, { menuHeading: menuHeading, menuSelectButtonLabel: menuSelectButtonLabel, menuClearButtonLabel: menuClearButtonLabel, menuDoneButtonLabel: menuDoneButtonLabel, clearable: clearable, onMenuSelectButtonClick: onMenuSelectButtonClick, onDone: onDone, onClear: onClear }, menuContent))));
};
const BubbleFilterButton = Depot.withRef(BubbleFilterButtonWithoutRef);
BubbleFilterButton.displayName = 'BubbleFilterButton';
export default BubbleFilterButton;
//# sourceMappingURL=index.js.map